export default __webpack_public_path__ + "static/media/color-mathmatics.dd75eb0d.svg";